import loglevel from 'loglevel';

const getPrefix = (
  methodName: string,
  colorArg?: string,
  backgroundArg?: string
) => {
  const color: string = colorArg ?? '#01161e';
  const background: string = backgroundArg ?? color;

  return [
    `%c${new Date().toLocaleTimeString()} %c${methodName}`,
    `color: ${color};`,
    `background: ${background}; color: #ffffff; padding: 4px; border-radius: 4px;`
  ];
};

const info = (...args: unknown[]) => {
  loglevel.info(...getPrefix('info', '#214dff'), ...args);
};

const trace = (...args: unknown[]) => {
  if (loglevel.getLevel() > loglevel.levels.TRACE) {
    return;
  }

  console.groupCollapsed(
    ...getPrefix('trace', 'currentColor', '#01161e'),
    ...args
  );
  console.trace();
  console.groupEnd();
};

const debug = (...args: unknown[]) => {
  loglevel.debug(...getPrefix('debug', '#03ba9c'), ...args);
};

const error = (...args: unknown[]) => {
  loglevel.error(...getPrefix('error', '#d8094b'), ...args);
};

const warn = (...args: unknown[]) => {
  loglevel.warn(...getPrefix('warn', '#ffa82e'), ...args);
};

const log = {
  setLevel: loglevel.setLevel,
  debug,
  /** @deprecated Consider using captureError instead */
  error,
  info,
  trace,
  warn
};

export default log;
